import {
  createLockManagerFromNavigatorLocks,
  createSingleProcessLockManager,
  type LockManager,
} from "@njbsoft/field-sync";

/**
 * How this host takes a fieldwork lock, resolved in ONE place so every holder
 * — the sync engine, the logout teardown and the capture screen's per-draft
 * hold — contends on the same mechanism rather than on three lookalikes.
 *
 * A real capability check, not a guess: `navigator.locks` is universal across
 * the supported browser matrix, and the single-process fallback is what a
 * lockless runtime (jsdom) gets — correct there, because one JS context has no
 * sibling holder to contend with.
 */
export function resolveLockManager(): LockManager {
  return typeof navigator !== "undefined" && navigator.locks
    ? createLockManagerFromNavigatorLocks(navigator.locks)
    : createSingleProcessLockManager();
}
